import type { ForwardedRef } from 'react';
import { Suspense, lazy, forwardRef } from 'react';

import type { AlertProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const MUIAlert = lazy(() => import('@mui/material/Alert'));

const StyledMUIAlert = styled(MUIAlert)(() => ({
  '& .MuiAlert-icon': {
    color: 'inherit',
  },
}));

type TRef = HTMLDivElement | null;

function TempAlert(props: AlertProps, ref: ForwardedRef<TRef>) {
  const { severity = 'error' } = props as AlertProps;

  let bg = 'bg-error-alert-background';
  let borderColor = 'border-error-dark';

  if (severity === 'success') {
    bg = 'bg-success-alert-background';
    borderColor = 'border-success-dark';
  } else if (severity === 'info') {
    bg = 'bg-info-alert-background';
    borderColor = 'border-info-dark';
  } else if (severity === 'warning') {
    bg = 'bg-warning-alert-background';
    borderColor = 'border-warning-dark';
  }

  return (
    <Suspense fallback={<div />}>
      <StyledMUIAlert
        className={`mb-2 items-center rounded-xl font-medium text-text-secondary ${bg} ${borderColor}`}
        severity={severity}
        ref={ref}
        variant="outlined"
        {...props}
      />
    </Suspense>
  );
}

const AtpAlert = forwardRef<TRef, AlertProps>(TempAlert);

export default AtpAlert;
